import type { Promotion } from "./types.js";

export const PROMOTION_IMAGE_LIMIT = 2 * 1024 * 1024;
export const PROMOTION_DETAIL_IMAGE_LIMIT = 8;
export const PROMOTION_IMAGE_CAPTION_LIMIT = 2000;
export type PromotionDetailImage = { image: string; caption: string };
export const PROMOTION_IMAGE_TYPES = ["image/png", "image/jpeg", "image/webp"];
export type PromotionList = { promotions: Promotion[]; total: number; page: number; pageSize: number; tags: string[]; serverNow: string };
const localDate = new Intl.DateTimeFormat("sv-SE", { timeZone: "Asia/Shanghai", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false });

export function promotionDateInput(value?: string | null) { return value ? localDate.format(new Date(value)).replace(" ", "T") : ""; }
export function promotionDateIso(value: string) {
  if (!value) return null;
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) throw new Error("请选择完整的日期和时间。");
  const date = new Date(`${value}:00+08:00`);
  if (!Number.isFinite(date.getTime()) || promotionDateInput(date.toISOString()) !== value) throw new Error("日期或时间无效，请重新选择。");
  return date.toISOString();
}
export function promotionStatus(item: Promotion, now = Date.now()): "active" | "scheduled" | "expired" | "disabled" {
  if (!item.active) return "disabled";
  if (item.startAt && (!Number.isFinite(Date.parse(item.startAt)) || Date.parse(item.startAt) > now)) return "scheduled";
  if (item.endAt && (!Number.isFinite(Date.parse(item.endAt)) || Date.parse(item.endAt) <= now)) return "expired";
  return "active";
}
export function promotionPeriod(item: Promotion) {
  if (!item.startAt && !item.endAt) return "长期活动";
  const start = item.startAt ? localDate.format(new Date(item.startAt)) : "即日起";
  const end = item.endAt ? localDate.format(new Date(item.endAt)) : "长期有效";
  return `${start} — ${end}（北京时间）`;
}
